import styled from 'styled-components'
import { Skeleton } from '~/components/shared'

export const MainHealthProcedureDetailsContainer = styled.div`
  flex: 1;
  margin: 20px;
  position: relative;
  height: calc(100vh - 110px);
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const MessageError = styled.p`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
`

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
`
export const SkeletonItem = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.colors.colorf2f7ff
}))`
  margin-bottom: 10px;
  border-radius: 2px;
  margin-right: 8px;
`

export const ContentInLine = styled.div`
  display: flex;
  flex-direction: row;
`

export const ContainerBottom = styled.div`
  margin-bottom: 18px;
  bottom: 0;
  position: absolute;
  width: 90%;
  text-align-last: center;
`
